export default __webpack_public_path__ + "static/media/avanto.a7ed814e.svg";